import getAdvertPosition from "../getAdvertPosition";
import { useEffect, useState, useCallback, useMemo } from "react";
import debounce from "./debounce";

export const useHandleResize = () => {
  const [adPosition, setAdPosition] = useState(getAdvertPosition());

  const handleResize = useCallback(() => {
    setAdPosition(getAdvertPosition());
  }, []);

  const debouncedHandleResize = useMemo(
    () => debounce(handleResize, 100),
    [handleResize]
  );

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);

    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, [debouncedHandleResize]);

  return { adPosition };
};
export default useHandleResize;
